module.exports = __webpack_public_path__ + "static/media/icon-approved.02d643e9.svg";